




















import { User } from '@/shared/user';
import { UserRole } from '@/shared/user-role';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class UsersTable extends Vue {
    @Prop({ required: true }) private users!: Array<User>;

    private currentPage: number = 1;
    private pageSize: number = 25;

    private get userFields(): Array<{}> {
        return [
            { key: 'firstName', label: 'First Name' },
            { key: 'lastName', label: 'Last Name' },
            { key: 'email', label: 'Email' },
            { key: 'roles', label: 'Roles' },
            { key: 'status', label: 'Status' },
            { key: 'actions', label: '', class: 'col-1', tdClass: 'text-right' },
        ];
    }

    private get totalRows(): number {
        return this.users.length;
    }

    private get paginationDescription(): string {
        const start = this.users.length < 1 ? 0 : ((this.currentPage - 1) * this.pageSize) + 1;
        const end = start + this.pageSize > this.totalRows ? this.totalRows : start + this.pageSize - 1;

        return `Showing ${start.toLocaleString()} - ${end.toLocaleString()} of ${this.totalRows.toLocaleString()}`;
    }

    private userRoles(user: User): Array<UserRole> {
        if (user.roles == null || !user.roles.length) {
            return [];
        }

        return [...user.roles]
            .sort((a, b) => {
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                return 0;
            });
    }
}
